/** Use to ensure a switch-case is exhaustive or other situations where a type should be never. */
export function assertNever(_var: never) {
  /** do nothing */
}

/** Version of `assertNever` that throws an error if the function is reached. */
export function assertNeverThrow(_var: never): never {
  throw new Error('Unreachable branch was reached.')
}
